import TextArea from "common/widgets/TextArea/TextArea";
const DFAutoresizeTextArea = TextArea.extend({

    options: {
        name: "DFAutoresizeTextArea"
    },

    /**
     * Override
     */
    _render: function() {
        TextArea.fn._render.apply(this, arguments);
        this.wrapper.addClass("expandingText");
        this.text = $("<div>").addClass("readText");
        this.notification.before(this.text);
    },

    /**
     * Override
     */
    _inputChange: function() {
        this.text.text(this.element.val());
        TextArea.fn._inputChange.apply(this, arguments);
    },

    /**
     * Override
     */
    value: function(val) {
        var result = TextArea.fn.value.apply(this, arguments);
        if (arguments.length) {
            this.text.text(val === null || val === undefined ? "" : val);
        }
        return result;
    },

    /**
     * Override
     */
    destroy: function() {
        TextArea.fn.destroy.apply(this, arguments);
        delete this.text;
    }
});
kendo.ui.plugin(DFAutoresizeTextArea);
export default DFAutoresizeTextArea;
